export default __webpack_public_path__ + "static/IBMPlexSans-ThinItalic-Greek-23bcd8de150396109df2f7b2cecb795d.woff";